import { Button, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { AccountListDrawer } from "./AccountListDrawer";

export const AccountListing: React.FC<any> = React.memo((props) => {
    const [cartOpen, setCartOpen] = useState(false);
    const navigate = useNavigate()
    const handleCartClick = () => {
        setCartOpen(true);
    };
    
    const handleCartClose = () => {
        setCartOpen(false);
    };

    const columns: IColumns[] = [
        {
            header: "Alias",
            fieldName: "workLocationName",
            tooltip: true,
        },
        {
            header: "Account Name",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Contact Person",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "City",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Phone",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Email",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Credit Limit",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Balance",
            fieldName: "address",
            tooltip: true,
        },
    ];

    const handleClick = (path:string) =>{
        navigate(path)
       }
     

    return (
        <Grid container direction="column"  sx={{ minHeight: '100vh' }}>
            {/* Header Section */}
            <Grid item>
                <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px' }}>
                    {/* Title on the left */}
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: "green" }}>
                        Account List
                    </Typography>
                    <Grid sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IconButton>
                            <WSIcons.SyncIcon />
                        </IconButton>
                        <IconButton onClick={handleCartClick}>
                            <WSIcons.SearchIcon />
                        </IconButton>
                        <AccountListDrawer open={cartOpen} onClose={handleCartClose} />
                        <IconButton>
                            <WSIcons.CloseIcon sx={{ backgroundColor: 'red', color: 'white' }} onClick={()=>handleClick('/')}/>
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>

            {/* DataGrid Section */}
            <Grid item sx={{ flex: 1 }}>
                <WSDataGrid
                    id="itemGrid"
                    title=""
                    columns={columns}
                />
            </Grid>

            {/* Footer Section */}
            <Grid
  item
  sx={{
    backgroundColor: "#333",
    padding: "1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  {/* Icon on the left */}
  <Grid item>
    <WSIcons.GTranslateIcon sx={{ color: "white" }} />
  </Grid>

  {/* Buttons on the right */}
  <Grid item sx={{ display: "flex", marginLeft: "auto" }}>
    <Button
      variant="contained"
      sx={{
        width: "13rem",
        backgroundColor: "green",
        "&:hover": {
          backgroundColor: "#388e3c",
        },
      }}
      onClick={()=>handleClick('/paymentposting')}
    >
      Payment Posting
    </Button>
    <Button
      variant="contained"
      sx={{
        ml: 2,  // Adds space between the buttons
        backgroundColor: "green",
        "&:hover": {
          backgroundColor: "#388e3c",
        },
      }}
      onClick={()=>handleClick('/paymentlist')}

    >
      Payment
    </Button>
  </Grid>
</Grid>

        </Grid>
    );
});
